import { ClaimOperator } from './ClaimOperator';
import { QueryDocumentsDto } from './QueryDocumentsDto';

export class ClaimsQueryDto {

    private providerId: Number;
    private claimAdministratorId: Number;
    private isAnswered: Boolean;
    private tpaId: Number;
    private claimId: String;
    private claimStatus: String;
    private isActive: Boolean;
    private remarks: String;
    private raisedBy: ClaimOperator;
    private answeredBy: ClaimOperator;
    private timestamp: Date;
    private queryId: Number;
    private queryDocuments!: QueryDocumentsDto[];
    private queryResponse: String;
    private queryResponseTimestamp: Date;
    private totalAmount: number = 0;

    constructor(claimsQueryDto: any) {
        this.queryResponse = claimsQueryDto.queryResponse;
        this.claimAdministratorId = claimsQueryDto.claimAdministratorId;
        this.isAnswered = claimsQueryDto.isAnswered;
        this.claimStatus = claimsQueryDto.claimStatus;
        this.isActive = claimsQueryDto.isActive;
        this.providerId = claimsQueryDto.providerId;
        this.tpaId = claimsQueryDto.tpaId;
        this.claimId = claimsQueryDto.claimId;
        this.remarks = claimsQueryDto.remarks;
        this.timestamp = claimsQueryDto.timestamp;
        this.queryResponseTimestamp = claimsQueryDto.queryResponseTimestamp;
        this.queryId = claimsQueryDto.queryId;
        this.totalAmount = claimsQueryDto.totalAmount || 0;
        if (claimsQueryDto.raisedBy) {
            this.raisedBy = new ClaimOperator(claimsQueryDto.raisedBy);
        } else {
            this.raisedBy = new ClaimOperator({});
        }

        if (claimsQueryDto.answeredBy) {
            this.answeredBy = new ClaimOperator(claimsQueryDto.answeredBy);
        } else {
            this.answeredBy = new ClaimOperator({});
        }



        if (claimsQueryDto.queryDocuments) {
            this.queryDocuments = [];
            for (const doc of claimsQueryDto.queryDocuments) {
                if (doc) {
                    this.queryDocuments.push(new QueryDocumentsDto(doc));
                }
            }
        }

    }


    /**
     * Getter $queryResponseTimestamp
     * @return {Date}
     */
    public get $queryResponseTimestamp(): Date {
        return this.queryResponseTimestamp;
    }

    /**
     * Setter $queryResponseTimestamp
     * @param {Date} value
     */
    public set $queryResponseTimestamp(value: Date) {
        this.queryResponseTimestamp = value;
    }

    /**
     * Getter $queryResponse
     * @return {String}
     */
    public get $queryResponse(): String {
        return this.queryResponse;
    }

    /**
     * Setter $queryResponse
     * @param {String} value
     */
    public set $queryResponse(value: String) {
        this.queryResponse = value;
    }

    /**
     * Getter $queryId
     * @return {Number}
     */
    public get $queryId(): Number {
        return this.queryId;
    }

    /**
     * Setter $queryId
     * @param {Number} value
     */
    public set $queryId(value: Number) {
        this.queryId = value;
    }

    /**
     * Getter $claimAdministratorId
     * @return {Number}
     */
    public get $claimAdministratorId(): Number {
        return this.claimAdministratorId;
    }



    /**
     * Getter $claimStatus
     * @return {String}
     */
    public get $claimStatus(): String {
        return this.claimStatus;
    }

    /**
     * Getter $isActive
     * @return {Boolean}
     */
    public get $isActive(): Boolean {
        return this.isActive;
    }

    /**
     * Setter $claimAdministratorId
     * @param {Number} value
     */
    public set $claimAdministratorId(value: Number) {
        this.claimAdministratorId = value;
    }


    /**
     * Getter $isAnswered
     * @return {Boolean}
     */
    public get $isAnswered(): Boolean {
        return this.isAnswered;
    }

    /**
     * Setter $isAnswered
     * @param {Boolean} value
     */
    public set $isAnswered(value: Boolean) {
        this.isAnswered = value;
    }


    /**
     * Setter $claimStatus
     * @param {String} value
     */
    public set $claimStatus(value: String) {
        this.claimStatus = value;
    }

    /**
     * Setter $isActive
     * @param {Boolean} value
     */
    public set $isActive(value: Boolean) {
        this.isActive = value;
    }

    /**
     * Getter $providerId
     * @return {Number}
     */
    public get $providerId(): Number {
        return this.providerId;
    }

    /**
     * Getter $tpaId
     * @return {Number}
     */
    public get $tpaId(): Number {
        return this.tpaId;
    }

    /**
     * Getter $claimId
     * @return {String}
     */
    public get $claimId(): String {
        return this.claimId;
    }

    /**
     * Getter $remarks
     * @return {String}
     */
    public get $remarks(): String {
        return this.remarks;
    }

    /**
     * Getter $raisedBy
     * @return {ClaimOperator}
     */
    public get $raisedBy(): ClaimOperator {
        return this.raisedBy;
    }

    /**
     * Getter $answeredBy
     * @return {ClaimOperator}
     */
    public get $answeredBy(): ClaimOperator {
        return this.answeredBy;
    }

    /**
     * Getter $timestamp
     * @return {Date}
     */
    public get $timestamp(): Date {
        return this.timestamp;
    }

    /**
     * Getter $queryDocuments
     * @return {QueryDocumentsDto[]}
     */
    public get $queryDocuments(): QueryDocumentsDto[] {
        return this.queryDocuments;
    }

    /**
     * Setter $providerId
     * @param {Number} value
     */
    public set $providerId(value: Number) {
        this.providerId = value;
    }

    /**
     * Setter $tpaId
     * @param {Number} value
     */
    public set $tpaId(value: Number) {
        this.tpaId = value;
    }

    /**
     * Setter $claimId
     * @param {String} value
     */
    public set $claimId(value: String) {
        this.claimId = value;
    }

    /**
     * Setter $remarks
     * @param {String} value
     */
    public set $remarks(value: String) {
        this.remarks = value;
    }

    /**
     * Setter $raisedBy
     * @param {ClaimOperator} value
     */
    public set $raisedBy(value: ClaimOperator) {
        this.raisedBy = value;
    }

    /**
     * Setter $answeredBy
     * @param {ClaimOperator} value
     */
    public set $answeredBy(value: ClaimOperator) {
        this.answeredBy = value;
    }

    /**
     * Setter $timestamp
     * @param {Date} value
     */
    public set $timestamp(value: Date) {
        this.timestamp = value;
    }

    /**
     * Setter $queryDocuments
     * @param {QueryDocumentsDto[]} value
     */
    public set $queryDocuments(value: QueryDocumentsDto[]) {
        this.queryDocuments = value;
    }

    /**
     * Getter $totalAmount
     * @return {number}
     */
    public get $totalAmount():number {
        return this.totalAmount;
    }

    /**
     * Setter $totalAmount
     * @param {number} value
     */
    public set $totalAmount(value:number){
        this.totalAmount = value;
    }
}
